module.exports = __webpack_public_path__ + "static/media/The Classic Trio.21ee8e96.png";